// @ts-strict-ignore
import type { PopulatedThreshold } from 'flow/store/engine/types';

export const getDollarCurrencyRightAttributeValueMode = (thresholdLeft: PopulatedThreshold['left']) => {
  if (!thresholdLeft?.service || !thresholdLeft?.attribute) return false;
  const leftAttributeTHMLA = [
    'th_multilevel',
    'th_nonmonetary_multilevel',
  ].includes(thresholdLeft.attribute.attribute_name);
  const mlaFormulatAttributeComponent = thresholdLeft.attributeComponents?.find(
    component => component.attributeComponent.placeholder === '{formula}');

  if (!mlaFormulatAttributeComponent?.value) return false;
  const mlaFormulaConfiguredForDollarRHSMode = [
    'sum',
    'avg',
    'min',
    'max',
    'st_dev_amount',
  ].includes(mlaFormulatAttributeComponent.value as string);

  return (
    leftAttributeTHMLA
      && mlaFormulatAttributeComponent
      && mlaFormulaConfiguredForDollarRHSMode
  );
};
